import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=7106c2ac&scoped=true&"
import script from "./HeaderButtons.vue?vue&type=script&lang=ts&"
export * from "./HeaderButtons.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderButtons.vue?vue&type=style&index=0&id=7106c2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106c2ac",
  null
  
)

export default component.exports